import React, { FunctionComponent, useEffect, useState } from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { DashboardEditorProps } from '../../ComponentType';
import { SparkLineProps } from './SparkLine';
import { DatasetDropdown } from '../../basic/dropdowns/dataset/DatasetDropdown';

const defaultSparkLineConfig: SparkLineProps = {
    valueScaling: 1,
    decimalPlaces: 0,
    labelFontSize: '2rem',
    sparkLineWidth: 300,
    dataset: '',
    count: 14,
    unit: '',
    showMinMax: false,
    showCurrent: false,
    updateFrequency: 0,
};

function SparkLineEditor({ config, onConfigChange }: DashboardEditorProps<SparkLineProps>) {
    let conf = config ?? defaultSparkLineConfig;

    if (Object.keys(conf).length === 0) {
        conf = defaultSparkLineConfig;
    }
    const [currentConfig, setCurrentConfig] = useState(conf);

    useEffect(() => {
        onConfigChange(currentConfig);
    }, [currentConfig]);

    const setConfigPropertyState = (property: keyof SparkLineProps, value: any) => {
        setCurrentConfig((prevState) => ({ ...prevState, [property]: value }));
    };

    const handleConfigChange = (e: any): void => {
        setConfigPropertyState(e.target.id as keyof SparkLineProps, e.target.value);
    };

    const handleDatasetChange = (e: any): void => {
        setConfigPropertyState("dataset" as keyof SparkLineProps, e);
    };

    return (
        <div className="grid">
            <div className="col-12 mb-3">
                <label htmlFor='dataset'>Dataset</label>
                <DatasetDropdown id='dataset' value={currentConfig.dataset} onChange={handleDatasetChange} />
            </div>
            <div className="col-4 flex flex-column mb-3">
                <label htmlFor='count'>Count</label>
                <InputNumber id='count' value={currentConfig.count} onValueChange={handleConfigChange} />
            </div>
            <div className="col-4 flex flex-column mb-3">
                <label htmlFor='updateFrequency'>Update Frequency</label>
                <InputNumber
                    id='updateFrequency'
                    value={currentConfig.updateFrequency}
                    onValueChange={handleConfigChange}
                />
            </div>
            <div className="col-4 flex flex-column mb-3">
                <label htmlFor='unit'>Unit</label>
                <InputText id='unit' type='text' value={currentConfig.unit} onChange={handleConfigChange} />
            </div>
            <div className="col-3 flex flex-column mb-3">
                <label htmlFor='valueScaling'>Value Scaling</label>
                <InputNumber id='valueScaling' value={currentConfig.valueScaling} onValueChange={handleConfigChange} />
            </div>
            <div className="col-3 flex flex-column mb-3">
                <label htmlFor='decimalPlaces'>Decimal Places</label>
                <InputNumber
                    id='decimalPlaces'
                    value={currentConfig.decimalPlaces}
                    onValueChange={handleConfigChange}
                />
            </div>
            <div className="col-3 flex flex-column mb-3">
                <label htmlFor='labelFontSize'>Label Font Size</label>
                <InputText
                    id='labelFontSize'
                    type='text'
                    value={currentConfig.labelFontSize}
                    onChange={handleConfigChange}
                />
            </div>
            <div className="col-3 flex flex-column mb-3">
                <label htmlFor='sparkLineWidth'>Spark Line Width</label>
                <InputNumber
                    id='sparkLineWidth'
                    value={currentConfig.sparkLineWidth}
                    onValueChange={handleConfigChange}
                />
            </div>
            <div className="flex gap-3">
                <div className='flex flex-column justify-content-center align-items-center'>
                    <label htmlFor='showMinMax'>MinMax</label>
                    <InputSwitch id='showMinMax' checked={currentConfig.showMinMax} onChange={handleConfigChange} />
                </div>
                <div className='flex flex-column justify-content-center align-items-center'>
                    <label htmlFor='showCurrent'>Show Current</label>
                    <InputSwitch id='showCurrent' checked={currentConfig.showCurrent} onChange={handleConfigChange} />
                </div>
            </div>

        </div>
    );
}

export default SparkLineEditor as FunctionComponent;
